<template>
  <div class="withdraw">
    <div>
      <van-nav-bar @click-left="navTo('/account')" fixed placeholder :title="$t('nav.withdraw')">
        <template #left>
          <van-icon color="#000" name="arrow-left" />
        </template>
      </van-nav-bar>
    </div>

    <div v-if="!show">
      <div class="content-section" style="margin-top: 20px">
        <van-field v-model="userInfo.account" name="" label="" placeholder="Bitcoin Address" style="margin: 0 auto" />
      </div>

      <div class="content-section" style="margin-top: 20px">
        <van-field v-model="accountPassword" type="password" name="" label="" placeholder="Set withdrawal password"
          style="margin: 0 auto" />
      </div>

      <div class="content-section" style="margin-top: 20px">
        <van-row>
          <van-col span="16">
            <van-field v-model="captcha.code" name="" label="" placeholder="Please enter the verification code"
              style="margin: 0 auto" />
          </van-col>
          <van-col span="8">
            <van-image width="100" height="48" :src="captcha.img" @click="changeCaptcha" />
          </van-col>
        </van-row>
      </div>

      <div style="margin: 16px">
        <van-button @click="accountClick" round block type="info" native-type="">{{ $t("button.account") }}</van-button>
      </div>
    </div>

    <div v-else class="content-section" style="margin-top: 10px">
      <div style="text-align: left; padding: 10px 10px 0 10px">
        {{ $t("withdraw.cash") }}
      </div>
      <div style="padding: 10px">
        <van-row>
          <van-col span="16">
            <van-field v-model="bill.nums" type="number" name="" label="" :placeholder="'Limit ' + userInfo.quota + '$'"
              style="margin: 0 auto; border-radius: 10px; margin-bottom: 10px" />
          </van-col>
          <van-col span="8">
            <div @click="allWithdraw" style="color: #c58e5d; height: 54px; line-height: 54px">
              {{ $t("withdraw.all") }}
            </div>
          </van-col>
        </van-row>
      </div>
      <div style="color: #999; text-align: left; padding: 10px 10px 0 10px">
        Available Balance ${{ showMoney }}
      </div>
      <div>
        <div style="margin: 16px">
          <van-button class="button-background" style="width: 80%; margin: 0 auto; border: 1px solid #eee" round block
            plain type="" native-type="" @click="withdraw">{{ $t("button.withdraw") }}</van-button>
        </div>
      </div>

      <van-dialog v-model="dialogShow" title="Please enter the withdrawal password" show-cancel-button
        @confirm="withdrawConfirm">
        <div class="content-section" style="margin-top: 20px">
          <van-field v-model="confirmAccountPassword" type="password" name="" label="" style="margin: 0 auto" />
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import {
  rechargeBalance,
  captcha,
  submitAccount,
  getInfo,
} from "@/common/api/api";

export default {
  name: "withdraw",
  data() {
    return {
      currency: "",
      value: "",
      bill: {
        nums: "",
      },
      userInfo: {},
      money: "",
      showMoney: "",
      quota: "",
      config: {},
      show: false,
      captcha: {
        img: "",
        key: "",
        code: "",
      },
      accountPassword: "",
      dialogShow: false,
      confirmAccountPassword: "",
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.quota = this.userInfo.quota;
    // console.log(this.userInfo);
    if (this.userInfo.account) {
      this.show = true;
      // console.log("show", this.show);
    } else {
      this.getCaptcha();
    }
    this.money = this.userInfo.money;
    this.showMoney = this.userInfo.showMoney;
    this.config = this.$store.getters.config;
    // console.log(this.config)
  },
  methods: {
    getCaptcha() {
      captcha().then((res) => {
        // console.log("captcha",res);
        this.captcha.img = res.data;
        this.captcha.key = res.key;
      });
    },
    changeCaptcha() {
      this.getCaptcha();
    },
    accountClick() {
      const accountInfo = {
        account: this.userInfo.account,
        accountPassword: this.accountPassword,
        code: this.captcha.code,
        key: this.captcha.key,
        userId: this.userInfo.userId,
      };
      submitAccount(accountInfo)
        .then((res) => {
          if (res.code == 20011) {
            this.$toast.fail({
              duration: 5000,
              message: "Verification code error",
            });
            return;
          }
          this.show = true;
        })
        .catch(() => { });
    },
    navTo(path) {
      this.$router.push(path);
    },
    allWithdraw() {
      this.bill.nums = this.money;
    },
    withdraw() {
      // if (!this.bill.accountInfo) {
      //   this.$toast.fail({
      //     duration: 5000,
      //     message: "Account information cannot be empty",
      //   });
      //   return;
      // }
      if (this.bill.nums < this.config.lowestWithdrawCash) {
        this.$toast.fail({
          duration: 5000,
          message:
            "The withdrawal amount is too low, the minimum is " +
            this.config.lowestWithdrawCash,
        });
        return;
      }
      if (this.bill.nums > this.config.maxWithdrawCash) {
        this.$toast.fail({
          duration: 5000,
          message:
            "The withdrawal amount is too high, the maximum amount is" +
            this.config.maxWithdrawCash,
        });
        return;
      }
      if (this.bill.nums > this.money) {
        this.$toast.fail({
          duration: 5000,
          message: "Insufficient amount",
        });
        return;
      }
      // if (this.userInfo.withdrawNum < 1) {
      //   this.$toast.fail({
      //     duration: 5000,
      //     message: "The number of withdrawals this quarter has reached the limit",
      //   });
      //   return;
      // }
      if (this.bill.nums > this.userInfo.quota) {
        this.$toast.fail({
          duration: 5000,
          message: "Please upgrade your VIP level to get higher amounts",
        });
        return;
      }
      this.dialogShow = true;
    },
    withdrawConfirm() {
      this.bill.userId = this.userInfo.userId;
      this.bill.uid = this.userInfo.username + "(" + this.userInfo.userId + ")";
      this.bill.accountPassword = this.confirmAccountPassword;
      // console.log(this.bill)
      rechargeBalance(this.bill, "2").then((res) => {
        this.confirmAccountPassword = "";
        this.bill.accountPassword = "";
        if (res.code == 20011) {
          this.$toast.fail({
            duration: 5000,
            message: "Wrong payment password",
          });
          return;
        }
        if (res.code == 20010) {
          this.$toast.fail({
            duration: 5000,
            message: "Withdrawal failed",
          });
          return;
        }
        this.bill.nums = "";
        // this.$store.dispatch("getInfo");
        if (res.code == 200) {
          getInfo().then((res) => {
            this.userInfo = res.data;
            this.money = this.userInfo.money;
            this.showMoney = this.userInfo.showMoney;
            this.quota = this.userInfo
          });
          this.$toast.success({
            duration: 5000,
            message: "Withdraw successfully",
          });
        }
      });
    },
  },
};
</script>

<style>
.content-section {
  border: 1px solid #eee;
  border-radius: 4px;
  margin: 0 10px 10px 10px;
}

.button-background {
  background: linear-gradient(90deg, #d4b38f 0%, #b88964 100%);
  color: #fff;
}
</style>
